import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf} from 'views/Shared'
import {GoDotFill} from 'react-icons/go'

export const ItemInformation = ({
  label,
  value,
  className = 'text-base italic',
  showIcon = false,
  colon = true,
  primary = false,
  style,
}) => {
  const t = useTranslate()
  return renderIf(
    value,
    <div
      style={style}
      className={classNames('space-x-1', className)}>
      {renderIf(
        showIcon === true,
        <GoDotFill
          size={className ? 10 : 12}
          className="text-color-400"
        />
      )}
      {renderIf(
        label,
        <span className="text-color-400 whitespace-no-wrap italic">
          {colon ? `${t(label)}: ` : t(label)}
        </span>
      )}
      <span
        className={
          primary === true
            ? 'font-bold text-gray-800'
            : value
            ? 'font-semibold text-color-100'
            : 'text-color-300 italic'
        }>
        {value ? value : t('not update')}
      </span>
    </div>
  )
}
